import { map as rxjsmap } from 'rxjs';



import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BusinessSettingViewDto } from '../models/business-setting.models';

@Injectable()
export class BusinessSettingService {
  constructor(private http: HttpClient) {}

  createAuthorizationHeader(headers: HttpHeaders) {
    headers.append('content-type', 'application/json');
  }
  getEmployee(id: number) {
    return this.http
      .get(
        environment.BASE_URL + '/project/ContactLookup/' + id,

      ).pipe(rxjsmap((result) => result));
  }
  getLanguage() {
    return this.http
      .get(
        environment.BASE_URL + '/master/languages',

      ).pipe(rxjsmap((result) => result));
  }
  addSetting(setting: BusinessSettingViewDto) {
    return this.http
      .post(
        environment.BASE_URL + '/business/settings',
        setting,

      ).pipe(rxjsmap((result) => result));
  }

  getSettingByBusiness(businessId: number) {
    return this.http
      .get(
        environment.BASE_URL + '/business/settings/' + businessId,

      ).pipe(rxjsmap((result) => result));
  }

  getSettingsByBusinessId(businessId: number): Observable<BusinessSettingViewDto | null> {
    if (businessId == null || businessId <= 0) {
      return new Observable<BusinessSettingViewDto | null>((observer) => {
        observer.next(null);
        observer.complete();
      });
    }
    const url = `${environment.BASE_URL}/business/settings/${businessId}`;
    return this.http.get<BusinessSettingViewDto>(url).pipe(rxjsmap((businessSetting: BusinessSettingViewDto) => businessSetting));
  }

  getPortalBusiness(businessId: number) {
    return this.http
      .get(
        environment.BASE_URL + '/business/portalbusiness/' + businessId,

      ).pipe(rxjsmap((result) => result));
  }
  updateBusinessSetting(setting: BusinessSettingViewDto) {
    return this.http
      .put(
        environment.BASE_URL + '/business/settings',
        setting,

      ).pipe(rxjsmap((result) => result));
  }
  getPortalContacts(userId: number) {
    return this.http
      .get<any>(
        environment.BASE_URL + '/portalcontactsbybusiness/' + userId,

      ).pipe(rxjsmap((result) => result));
  }

  reportGenerate(
    businessId: number,
    type: number,
    cultureInfo: string,
    ReportJson,
    applicationId: number
  ) {
    let dynamicType = 'application/pdf';
    let myData = { data: ReportJson };
    let url = `${environment.BASE_URL}/export-ourcompanydetailslist/${businessId}/${type}/${cultureInfo}/${applicationId}`;
    return this.http
      .post(url, myData, { responseType: 'blob' })
      .pipe(rxjsmap(blob => new Blob([blob], { type: dynamicType })));
  }
}
